export const fmtLeadDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso + "T00:00:00").toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
};

const TONES = {
  active: "bg-sky-50 text-sky-800 border-sky-200",
  completed: "bg-emerald-50 text-emerald-800 border-emerald-200",
  cancelled: "bg-stone-100 text-stone-500 border-stone-300 line-through",
};
const LABELS = { active: "Active", completed: "Completed", cancelled: "Cancelled" };

export const LeadStatusBadge = ({ status, testid }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] font-bold uppercase tracking-wider ${TONES[status] || TONES.active}`}
    data-testid={testid}
  >
    {LABELS[status] || status}
  </span>
);
